import {EmptyObject} from './EmptyObject';

export type BrandedType<T> = T & EmptyObject;
